import EmployeeActivationRequestStatus from './EmployeeActivationRequestStatus'
export class EmployeeActivationRequest {
    ID?: number;
    Username?: string;
    Location?: string;
    StatusID?: number;
    EmployeeActivationRequestStatus?: EmployeeActivationRequestStatus;
    CreatedBy?: string;
}

export default EmployeeActivationRequest;